import { INSTRUMENT_NOTE_TO_VOICE_MAP } from "../consts/score";
import { baseOf, soundAt } from "../lib/instruments";

// The sounds a score plays (or one of its parts): their staff positions, and names where they have them.
export function getScoreVoices(score, only = null) {
    let scoreVoices = new Set();
    const instrument = only || Object.keys(score.parts)[0];
    score.measures.forEach((measure) => {
      measure.parts.filter((part) => !only || part.instrument === only).forEach((part) => {
        part.voices.forEach((voice) => {
          voice.notes.forEach((note) => {
            note.notes.forEach((n) => {
              scoreVoices.add(n);
            });
          });
        });
      });
    });

    //Returning a 'map' so that the client can access both the key and the associated instrument name
    let keysToVoices = {};
    scoreVoices.forEach((key) => {
      keysToVoices[key] = INSTRUMENT_NOTE_TO_VOICE_MAP[baseOf(instrument)]?.[key] ?? soundAt(instrument, key)?.name ?? key;
    });

    return keysToVoices;
}